import { EMoneySource } from '../../../../../types/reducers/user';

// Этот костыль нужен, чтобы достучаться до кнопок в функциональных тестах
// ui-kit не создает на основе значения data-name
export const getOptionDataName = (source: EMoneySource) => {
  return `MoneySource${source.charAt(0).toUpperCase() + source.slice(1)}`;
};
